import EventCard from "@/components/EventCard";
import React, { useState, useEffect } from "react";
import S from "./Events.style";
import otherPic from "@/src/images/events/other.jpg";
import onlinePic from "@/src/images/events/online.jpg";
import stockholmPic from "@/src/images/events/stockholm.jpg";
import gothenburgPic from "@/src/images/events/goteborg.jpg";
import malmoPic from "@/src/images/events/malmo.jpg";
import osloPic from "@/src/images/events/oslo.jpg";
import { IEvent, useEventData } from "./useEventData";

export interface Props {
  numberOfEvents: any;
  url: string;
}

const Events: React.FC = () => {
  const [location, setLocation] = useState<string>("");
  const [posts, setPosts] = useState<IEvent[]>([]);
  const eventData = useEventData();

  const imageArray: { location: string; src: string }[] = [
    {
      location: "other",
      src: otherPic,
    },
    {
      location: "Stockholm",
      src: stockholmPic,
    },
    {
      location: "Göteborg",
      src: gothenburgPic,
    },
    {
      location: "Malmö",
      src: malmoPic,
    },
    {
      location: "Oslo",
      src: osloPic,
    },
    {
      location: "online",
      src: onlinePic,
    },
  ];

  useEffect(() => {
    if (eventData) {
      if (location === "") {
        setPosts(eventData);
      } else {
        const array = eventData.filter((item) => item.location === location);
        setPosts(array);
      }
    }
  }, [location]);

  return (
    <S.BlogWrapper>
      <div className="main-inner">
        <S.TitleWrapper>
          <S.Title>
            Event
            <S.Line />
          </S.Title>
          <S.LinkWrapper>
            <S.Button
              onClick={() => setLocation("")}
              className={` ${location === "" ? "active-link" : ""}`}
            >
              Alla
            </S.Button>
            {eventData && eventData.find((item) => item.location === "Stockholm") && (
              <S.Button
                onClick={() => setLocation("Stockholm")}
                className={` ${location === "Stockholm" ? "active-link" : ""}`}
              >
                Stockholm
              </S.Button>
            )}
            {eventData && eventData.find((item) => item.location === "Göteborg") && (
              <S.Button
                onClick={() => setLocation("Göteborg")}
                className={` ${location === "Göteborg" ? "active-link" : ""}`}
              >
                Göteborg
              </S.Button>
            )}
            {eventData && eventData.find((item) => item.location === "Malmö") && (
              <S.Button
                onClick={() => setLocation("Malmö")}
                className={` ${location === "Malmö" ? "active-link" : ""}`}
              >
                Malmö
              </S.Button>
            )}
            {eventData && eventData.find((item) => item.location === "Oslo") && (
              <S.Button
                onClick={() => setLocation("Oslo")}
                className={` ${location === "Oslo" ? "active-link" : ""}`}
              >
                Oslo
              </S.Button>
            )}
            {eventData && eventData.find((item) => item.location === "online") && (
              <S.Button
                onClick={() => setLocation("online")}
                className={` ${location === "online" ? "active-link" : ""}`}
              >
                Online
              </S.Button>
            )}
          </S.LinkWrapper>
        </S.TitleWrapper>
        <S.Container>
          {posts.map((item, index) => (
            <EventCard item={item} key={index} imageArray={imageArray} />
          ))}
          {posts.length === 0 && (
            <S.H3>
              För närvarande finns inga planerade event för denna plats.
            </S.H3>
          )}
        </S.Container>
      </div>
    </S.BlogWrapper>
  );
};

export default Events;
